/**
 * Maps app routes to stable keys for admin analytics (Data → Page visits).
 * Only paths matched here are logged — everything else is ignored.
 */

export const TRACKED_PAGE_KEYS = [
  'dashboard',
  'latest-pedals',
  'suggested-tab',
  'profile',
  'matches',
  'want-list-matches',
  'recommendations',
  'search',
  'news',
  'how-it-works',
  'my-pedals',
  'add-pedal',
];

export const PAGE_KEY_LABELS = {
  dashboard: 'Dashboard',
  'latest-pedals': 'Latest pedals',
  'suggested-tab': 'Suggested tab (Latest Pedals)',
  profile: 'Profile (your account)',
  matches: 'Matches & match tools',
  'want-list-matches': 'Wantlist Matches',
  recommendations: 'Match Opportunities',
  search: 'Search',
  news: 'News',
  'how-it-works': 'How it works',
  'my-pedals': 'My pedals hub',
  'add-pedal': 'Add a pedal',
};

const trackers = [
  { pageKey: 'dashboard', test: (p) => p === '/' || p === '/dashboard' },
  { pageKey: 'latest-pedals', test: (p) => p === '/latest-pedals' },
  { pageKey: 'profile', test: (p) => p === '/profile' },
  {
    pageKey: 'matches',
    test: (p) => p === '/matches' || p === '/saved-matches',
  },
  { pageKey: 'want-list-matches', test: (p) => p === '/want-list-matches' },
  { pageKey: 'recommendations', test: (p) => p === '/recommendations' },
  { pageKey: 'search', test: (p) => p.startsWith('/search') },
  { pageKey: 'news', test: (p) => p === '/news' },
  { pageKey: 'how-it-works', test: (p) => p === '/how-it-works' },
  {
    pageKey: 'my-pedals',
    test: (p) => p === '/my-pedals' || p.startsWith('/my-pedals/'),
  },
  { pageKey: 'add-pedal', test: (p) => p === '/addpedal' },
];

/**
 * @param {string} pathname — e.g. location.pathname (no query)
 * @returns {string | null} pageKey or null if not tracked
 */
export function resolveTrackedPageKey(pathname) {
  if (!pathname || typeof pathname !== 'string') return null;
  const p = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  for (const { pageKey, test } of trackers) {
    if (test(p)) return pageKey;
  }
  return null;
}
